import * as React from 'react'

export interface Props {
  name: string
  content: string
}

export default class Comment extends React.Component<Props> {
  render () {
    const { name, content } = this.props
    return (
      <div className='p1'>
        <div className='h5 bold'>{name}:</div>
        <div className='h4 pl2 pt1'>{content}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Comment.tsx